// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"_video__mainContent__hJPyt","h1":"_video__h1__aTnEL","h2":"_video__h2__kigBF","bigImage":"_video__bigImage__GYmZF"};